<template lang="pug">
a.promos-header__logo(href="/", :class="getClass")
  img(:src="getLogoImage")
</template>

<script>
export default {
  name: "PromosHeaderLogo",
  props: {
    hasBorder: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    getLogoImage() {
      return require("@static_common/images/global/logo.svg");
    },
    getClass() {
      return { "promos-header__logo--has-border": this.hasBorder };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/blocks/header-logo";
</style>